"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.getItems = getItems;
exports.getSelection = getSelection;
exports.getChangedSelection = getChangedSelection;
exports.getChangedDeselection = getChangedDeselection;
exports.rangeTo = exports.removeAll = exports.remove = exports.toggle = exports.replace = exports.setSelection = exports.setItems = void 0;

var _flow = _interopRequireDefault(require("./flow"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray2(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray2(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var curry = function curry(fn) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var arity = fn.length;
  return function () {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    var callArgs = args.concat(newArgs);

    if (callArgs.length < arity) {
      return curry(fn, callArgs);
    }

    return fn.apply(void 0, _toConsumableArray(callArgs));
  };
};

var clone = function clone(value) {
  return Array.from(value);
};

var difference = function difference(array, values) {
  return array.filter(function (v) {
    return !values.includes(v);
  });
};

var includes = function includes(value, collection) {
  return collection.includes(value);
};

var intersection = function intersection(a, b) {
  return a.filter(function (v) {
    return b.includes(v);
  });
};

var union = function union(a, b) {
  return _toConsumableArray(new Set(a.concat(b)));
};

var without = function without(value, array) {
  if (Array.isArray(value)) {
    var reducer = function reducer(accumulator, currentValue) {
      return without(currentValue, accumulator);
    };

    return value.reduce(reducer, array);
  }

  return array.filter(function (v) {
    return v !== value;
  });
};

function init() {
  return {
    items: [],
    selected: [],
    changed: {
      selected: [],
      deselected: []
    },
    anchor: null
  };
}

function _iterableToArray(iterable) {
  var array = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;
      array.push(item);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return array;
}

var setItems = curry(function (itemsIterable, state) {
  var items = _iterableToArray(itemsIterable);

  return {
    items: items,
    selected: intersection(state.selected, items),
    changed: {
      selected: [],
      deselected: difference(state.selected, items)
    },
    anchor: includes(state.anchor, items) ? state.anchor : null
  };
});
exports.setItems = setItems;
var setSelection = curry(function (selectedItems, state) {
  var selection = intersection(selectedItems, state.items);
  return {
    items: state.items,
    selected: selection,
    changed: {
      selected: without(state.selected, selection),
      deselected: without(selection, state.selected)
    },
    anchor: state.anchor
  };
});
exports.setSelection = setSelection;

function getItems(state) {
  return clone(state.items);
}

function getSelection(state) {
  return clone(state.selected);
}

function getChangedSelection(state) {
  return clone(state.changed.selected);
}

function getChangedDeselection(state) {
  return clone(state.changed.deselected);
}

function _getBottommostSelectedItem(state) {
  var previousItem = null;

  var isSelected = function isSelected(item) {
    return state.selected.indexOf(item) !== -1;
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = state.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var item = _step2.value;

      if (isSelected(item)) {
        previousItem = item;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return previousItem;
}

function _getAnchor(state) {
  if (state.anchor !== null && state.anchor !== undefined) {
    return state.anchor;
  }

  if (state.selected.length > 0) {
    return _getBottommostSelectedItem(state);
  }

  return state.items[0];
}

var replace = curry(function (selectedItem, state) {
  if (!includes(selectedItem, state.items)) {
    return state;
  }

  return {
    items: state.items,
    selected: [selectedItem],
    changed: {
      selected: without(state.selected, [selectedItem]),
      deselected: without([selectedItem], state.selected)
    },
    anchor: selectedItem
  };
});
exports.replace = replace;
var toggle = curry(function (toggledItem, state) {
  if (!includes(toggledItem, state.items)) {
    return state;
  }

  var itemIsAdded = !includes(toggledItem, state.selected);

  if (itemIsAdded) {
    return {
      items: state.items,
      selected: state.selected.concat([toggledItem]),
      changed: {
        selected: [toggledItem],
        deselected: []
      },
      anchor: toggledItem
    };
  }

  var anchorIsRemoved = toggledItem === state.anchor;
  var newAnchor = anchorIsRemoved ? null : state.anchor;
  return {
    items: state.items,
    selected: without([toggledItem], state.selected),
    changed: {
      selected: [],
      deselected: [toggledItem]
    },
    anchor: newAnchor
  };
});
exports.toggle = toggle;
var remove = curry(function (removedItems, state) {
  return {
    items: state.items,
    selected: without(removedItems, state.selected),
    changed: {
      selected: [],
      deselected: intersection(removedItems, state.selected)
    },
    anchor: null
  };
});
exports.remove = remove;
var removeAll = curry(function (state) {
  return {
    items: state.items,
    selected: [],
    changed: {
      selected: [],
      deselected: state.selected
    },
    anchor: null
  };
});
exports.removeAll = removeAll;

function _between(start, end, array) {
  if (start === end) {
    return [start];
  }

  var startIndex = array.indexOf(start);
  var endIndex = array.indexOf(end);

  if (startIndex > endIndex) {
    var temp = startIndex;
    startIndex = endIndex;
    endIndex = temp;
  }

  return array.slice(startIndex, endIndex + 1);
}

function _connectedWith(targetItem, selected, array) {
  var isSelected = function isSelected(item) {
    return selected.indexOf(item) !== -1;
  };

  var result = [];
  var targetIndex = array.indexOf(targetItem);

  for (var i = targetIndex; i >= 0; i -= 1) {
    if (!isSelected(array[i])) {
      break;
    }

    result.push(array[i]);
  }

  for (var _i = targetIndex; _i < array.length; _i += 1) {
    if (!isSelected(array[_i])) {
      break;
    }

    result.push(array[_i]);
  }

  return result;
}

var rangeTo = curry(function (toItem, state) {
  if (!includes(toItem, state.items)) {
    return state;
  }

  var anchor = _getAnchor(state, state.items);

  var connected = _connectedWith(anchor, state.selected, state.items);

  var range = _between(anchor, toItem, state.items);

  var selected = (0, _flow.default)(function (v) {
    return without(connected, v);
  }, function (v) {
    return union(range, v);
  })(state.selected);
  return {
    items: state.items,
    selected: selected,
    changed: {
      selected: without(state.selected, selected),
      deselected: without(selected, state.selected)
    },
    anchor: state.anchor
  };
});
exports.rangeTo = rangeTo;


//////////////////
// WEBPACK FOOTER
// ./~/yourchoice/lib/operations.js
// module id = 78
// module chunks = 0